import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Button,
  Card,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";

import { staticData } from "managers/staticDataManager";

import notificationManager from "managers/notificationManager";
import {
  authInitialize,
  changeIssuer,
  initializeChannels,
  changeChannel,
} from "store/accountActions";
import { dataManager } from "managers/data/dataManager";

const DecisionModal = ({
  state,
  isVisible,
  isBusy,
  setIsBusy,
  user,
  issuers,
  handlePostAuth,
  onHide,
  alertRef,
  ...rest
}) => {
  const dispatch = useDispatch();
  const [choosed, setChoosed] = useState(null);

  React.useEffect(() => {
    // console.log('React.useEffect-issuers: ', issuers.length, issuers);
    if (!issuers || issuers.length === 0) {
      return;
    }

    setChoosed(issuers[0]);
    // console.log('React.useEffect-issuers[0]: ', issuers[0]);

    if (issuers.length === 1) {
      // console.log('React.useEffect-single issuer: ', issuers.length, issuers[0]);
      performAuth();
    }
  }, [issuers]);

  const handleCancel = (e) => {
    setChoosed(null);
    onHide();
  };

  const handleIssuerChange = (e) => {
    if (!e.target.value) {
      return;
    }

    let selectedIssuerId = parseInt(e.target.value);
    let selectedIssuer = issuers.find((i) => i.issuerId === selectedIssuerId);
    setChoosed(selectedIssuer);
  };

  const handleIssuerClick = (e) => {
    // console.log('handleIssuerClick: ', choosed, e);
    if (!choosed) {
      notificationManager.error(
        state,
        null,
        alertRef,
        "VW_ISSUER_NOT_ASSOCIATED"
      );
      return;
    }

    performAuth();
  };

  const performAuth = () => {
    if (!choosed) {
      return;
    }

    dispatch(
      authInitialize({
        ...user,
        language: state.account?.language || user.language,
      })
    );

    dispatch(changeIssuer(choosed));
    handlePostAuth(choosed);
  };

  return (
    <Modal isOpen={isVisible} toggle={handleCancel}>
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          type="button"
          onClick={handleCancel}
        >
          <span aria-hidden={true}>×</span>
        </button>
        <h5 className="modal-title text-center" id="exampleModalLabel">
          {staticData.loadTerms(state, "VW_ISSUER_CHOOSE_ISSUER")}
        </h5>
      </div>
      <div className="modal-body">
        <Input
          id="ddlIssuersList"
          type="select"
          value={choosed?.issuerId}
          onChange={handleIssuerChange}
        >
          {issuers.map((issuer) => (
            <option
              key={issuer?.issuerId}
              data-key={issuer?.issuerId}
              value={issuer?.issuerId}
            >{`${issuer.code} - ${dataManager.getIssuerDisplayName(
              state,
              issuer
            )}`}</option>
          ))}
        </Input>
      </div>
      <div className="modal-footer">
        <Button
          id="btnSetIssuer"
          block
          className="btn-round"
          color="danger"
          type="button"
          disabled={isBusy}
          onClick={handleIssuerClick}
        >
          {isBusy
            ? "..."
            : staticData.loadTerms(state, "VW_ISSUER_Authenticate_BtnLogin")}
        </Button>
      </div>
    </Modal>
  );
};

export default DecisionModal;
